import { every, omit } from 'lodash';

import { actionTypes as types } from './actions';

const initalInputState = {
  isValid: true, // Indicates if all validations are passing.
  isDirty: false, // Indicates if the field has been changed since inititialization.
  isFocused: false, // Indicates if the field is currently in focus.
  isFocusedDirty: false, // Indicates if the field has been changed since coming into focus.
  istouched: false, // Indicates if the field has been in and out of focus at least once.
  validationValue: undefined, // The current value of the input used for validation.
  validations: undefined, // Any stored validations to run on the input during form submission.
  validationResults: {} // The results of the last validation. This is an object where each property is
                        // the validator and if it the validation passed.
};

/**
 * A reducer to manage the state of a single input within a form.
 */
export function input(state = initalInputState, action) {
  const { payload } = action;
  switch (action.type) {
    case types.CHANGE_INPUT: {
      return {
        ...state,
        isDirty: true,
        isFocusedDirty: state.isFocused && true
      };
    }
    case types.FOCUS_INPUT: {
      return {
        ...state,
        isFocused: true,
        isFocusedDirty: false
      };
    }
    case types.BLUR_INPUT: {
      return {
        ...state,
        isFocused: false,
        isFocusedDirty: false,
        isTouched: true
      };
    }
    case types.SET_INPUT_VALIDATIONS: {
      return {
        ...state,
        validations: payload.validations
      };
    }
    case types.SET_INPUT_VALIDATION_VALUE:
      return {
        ...state,
        validationValue: payload.value
      };
    case types.VALIDATE_INPUT: {
      return {
        ...state,
        validationValue: payload.value,
        isValid: every(payload.results, result => result.isValid),
        validationResults: payload.results
      };
    }
    default: {
      return state;
    }
  }
}

/**
 * A reducer to manage all inputs within a form.
 */
export default function inputs(state = {}, action) {
  const { payload = {} } = action;
  const { inputId } = payload;
  switch (action.type) {
    case types.ADD_INPUT:
      if (state[inputId]) { return state; }
      return { ...state, [inputId]: input(undefined, action) };
    case types.REMOVE_INPUT:
      if (!state[inputId]) { return state; }
      return omit(state, [inputId]);
    default: {
      const updatedInput = input(state[inputId], action);
      if (state[inputId] && updatedInput !== state[inputId]) {
        return { ...state, [inputId]: updatedInput };
      }
      return state;
    }
  }
}
